// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"08161b9e","442":"3cffd5db","444":"56606445","617":"76f989d7","745":"7dcaf06f","967":"39918cab"}[chunkId] + ".chunk.js";
};